import React, { FC } from 'react'
import styles from 'styles/components/typography.module.scss'

type Props = {
  info: string
}

const Info: FC<Props> = (props) => {
  const { info } = props
  return <p className={styles.description_blue}>{info}</p>
}

export default Info
